<template>
  <div ref="comparison" :style="style"></div>
</template>

<script>
  import * as echarts from 'echarts';

  export default {
    props: ['chartData', 'height', 'IIPSentToSite'],
    data() {
      return {
        data: [],
        style: '',
        myChart: {},
        date: '',
      };
    },
    created() {
      this.style = `margin:0px; width:100%;  min-height:${this.height}`;
      window.addEventListener('resize', () => {
        if (this.myChart !== null && this.myChart !== undefined) {
          this.myChart.resize();
        }
      });
    },
    destroyed() {
      this.myChart = null;
    },
    mounted() {
      this.myChart = echarts.init(this.$refs.comparison);
      let option;
      option = {
        legend: {
          data: this.chartData['definedData'],
          icon: 'roundRect',
        },
        tooltip: {
          trigger: 'axis',
          formatter: params => {
            if (params[0]['axisValue'] !== 'Site Selection') {
              if (params.length === 3) {
                return this.dataLegthThree(params);
              } else if (params.length === 2) {
                return this.dataLegthTwo(params[0], params[1], params[0]['axisValue']);
              } else if (params.length === 1) {
                return this.dataLegthOne(params[0], params[0]['axisValue']);
              }
            }
          },
        },
        xAxis: {
          boundaryGap: false,
          axisLabel: {
            interval: 'auto',
            showMaxLabel: true,
            showMinLabel: true,
            formatter: function(value) {
              const labelArray = value.split(' ');
              return labelArray.join('\n');
            },
          },
          axisTick: {
            alignWithLabel: true,
          },
          splitLine: {
            show: true,
          },
          splitNumber: 8,
          type: 'category',
          data: [
            'Site Selection',
            'IIP Sent to Site',
            'IRB/IEC Submission',
            'IRB/IEC Approval',
            'Clinical Study Agreement Fully Executed',
            'Site Initiation',
            'Site Activation',
            'FSFV',
          ],
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: true,
          },
        },
        series: this.chartData['definedSeries'],
      };

      option && this.myChart.setOption(option);
    },
    methods: {
      dataLegthThree(params) {
        return params[0]['axisValue'] === 'IIP Sent to Site'
          ? `<center><strong>IIP Sent to Site</strong> </center></br>
                  Days Elapsed since Site Selection</br>
                  <strong>My Site </strong>: ${params[0]['data']} <br />
                  <strong>My Country Average</strong>: ${params[1]['data']} <br />
                  <strong>Study Average</strong>: ${params[2]['data']} <br /> `
          : `<center><strong>${params[0]['axisValue']}</strong></center></br>
                  Days Elapsed since IIP Sent to Site </br>
                  <strong>My Site </strong>: ${params[0]['data'] -
                    this.IIPSentToSite['Site']} <br />
                  <strong>My Country Average</strong>: ${params[1]['data'] -
                    this.IIPSentToSite['CountryAverages']} <br />
                  <strong>Study Average</strong>: ${params[2]['data'] -
                    this.IIPSentToSite['StudyAverages']} <br /> `;
      },
      dataLegthTwo(data1, data2, axisValue) {
        if (data1['seriesName'] === 'My Site' && data2['seriesName'] === 'Study Average') {
          return axisValue === 'IIP Sent to Site'
            ? `<center><strong>IIP Sent to Site</strong> </center></br>
                 Days Elapsed since Site Selection</br>
                  <strong>My Site </strong>: ${data1['data']} <br />
                  <strong>Study Average</strong>: ${data2['data']} <br /> `
            : `<center><strong>${axisValue}</strong></center></br>
                  Days Elapsed since IIP Sent to Site </br>
                  <strong>My Site </strong>: ${data1['data'] - this.IIPSentToSite['Site']} <br />
                  <strong>Study Average</strong>: ${data2['data'] -
                    this.IIPSentToSite['StudyAverages']} <br /> `;
        } else if (
          data1['seriesName'] === 'My Site' &&
          data2['seriesName'] === 'My Country Average'
        ) {
          return axisValue === 'IIP Sent to Site'
            ? `<center><strong>IIP Sent to Site</strong> </center></br>
                 Days Elapsed since Site Selection</br>
                  <strong>My Site </strong>: ${data1['data']} <br />
                  <strong>My Country Average</strong>: ${data2['data']} <br /> `
            : `<center><strong>${axisValue}</strong></center></br>
                  Days Elapsed since IIP Sent to Site </br>
                  <strong>My Site </strong>: ${data1['data'] - this.IIPSentToSite['Site']} <br />
                  <strong>My Country Average</strong>: ${data2['data'] -
                    this.IIPSentToSite['CountryAverages']} <br /> `;
        } else if (
          data1['seriesName'] === 'My Country Average' &&
          data2['seriesName'] === 'Study Average'
        ) {
          return axisValue === 'IIP Sent to Site'
            ? `<center><strong>IIP Sent to Site</strong> </center></br>
                 Days Elapsed since Site Selection</br>
                  <strong>My Country Average</strong>: ${data1['data']} <br />
                  <strong>Study Average</strong>: ${data2['data']} <br /> `
            : `<center><strong>${axisValue}</strong></center></br>
                  Days Elapsed since IIP Sent to Site </br>
                  <strong>My Country Average</strong>: ${data1['data'] -
                    this.IIPSentToSite['CountryAverages']} <br />
                  <strong>Study Average</strong>: ${data2['data'] -
                    this.IIPSentToSite['StudyAverages']} <br /> `;
        }
      },
      dataLegthOne(data, axisValue) {
        if (data['seriesName'] === 'My Site') {
          return axisValue === 'IIP Sent to Site'
            ? `<center><strong>IIP Sent to Site</strong> </center></br>
                 Days Elapsed since Site Selection</br>
                  <strong>My Site </strong>: ${data['data']} <br /> `
            : `<center><strong>${axisValue}</strong></center></br>
                  Days Elapsed since IIP Sent to Site </br>
                 <strong>My Site </strong>: ${data['data'] - this.IIPSentToSite['Site']} <br /> `;
        } else if (data['seriesName'] === 'My Country Average') {
          return axisValue === 'IIP Sent to Site'
            ? `<center><strong>IIP Sent to Site</strong> </center></br>
                 Days Elapsed since Site Selection</br>
                 <strong>My Country Average</strong>: ${data['data']} <br /> `
            : `<center><strong>${axisValue}</strong></center></br>
                  Days Elapsed since IIP Sent to Site </br>
                <strong>My Country Average</strong>: ${data['data'] -
                  this.IIPSentToSite['CountryAverages']} <br /> `;
        } else if (data['seriesName'] === 'Study Average') {
          return axisValue === 'IIP Sent to Site'
            ? `<center><strong>IIP Sent to Site</strong> </center></br>
                 Days Elapsed since Site Selection</br>
                  <strong>Study Average</strong>: ${data['data']} <br />`
            : `<center><strong>${axisValue}</strong></center></br>
                  Days Elapsed since IIP Sent to Site </br>
                 <strong>Study Average</strong>: ${data['data'] -
                   this.IIPSentToSite['StudyAverages']} <br />`;
        }
      },
    },
  };
</script>

<style></style>
